<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/stujapcollect">日语汇总</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>缴费统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="年份">
          <el-date-picker
            v-model="year"
            type="year"
            value-format="yyyy"
            placeholder="选择年份"
            @change="yearSearch();"
          ></el-date-picker>
        </el-form-item>
        <template v-if="userIsAdmain">
          <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;">
            <el-select v-model="query.adviserID" filterable @change="getCollect()">
              <el-option label="请选择" value></el-option>
              <el-option
                v-for="item in adviserList"
                :label="item.realName"
                :value="item.userID"
                :key="item.userID"
                placeholder="请选择"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="营销" label-width="80px" style="margin-left:-15px;">
            <el-select v-model="query.marketID" filterable @change="getCollect()">
              <el-option label="请选择" value></el-option>
              <el-option
                v-for="item in marketList"
                :label="item.realName"
                :value="item.userID"
                :key="item.userID"
                placeholder="请选择"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="primary" @click="yearSearch();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always">
        <div class="clearfix" slot="header">
          <span>{{year}}年缴费月汇总详情</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-table :data="list" stripe style="width: 100%; ">
            <el-table-column prop="month" label="月份"></el-table-column>
            <el-table-column prop="totalAmount" label="缴费总额" sortable></el-table-column>
            <el-table-column prop="newEnrolAmount" label="新报总额" sortable></el-table-column>
            <el-table-column prop="renewAmount" label="续报总额" sortable></el-table-column>
            <el-table-column prop="percentage" label="提成总额" sortable></el-table-column>
            <el-table-column prop="payCount" label="缴费人数"></el-table-column>
            <el-table-column prop="quitCount" label="退出人数"></el-table-column>
            <el-table-column prop="allCount" label="资源总数"></el-table-column>
          </el-table>
          <div style="height:115px;"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      userIsAdmain: user.isAdmin(),
      list: [], //数据详情
      adviserList: [],
      marketList: [],
      year: ""
    };
  },
  methods: {
    //获取学校统计，地区统计
    getCollect() {
      var _this = this;
      _this.query.year = this.year;
      //柱状图
      var link2 = url.getJapCollect("GetPayAmount");
      $.get(link2, _this.query, data => {
        _this.list = data;
      });
    },
    //月份选择
    yearSearch() {
      this.getCollect();
    }
  },
  created() {},
  mounted() {
    var _this = this;
    this.year = new Date().getFullYear().toString();
    this.getCollect();

    //登录人处理
    if (this.userIsAdmain) {
      //加载顾问老师，文案老师
      $.get(url.getStu("getenableusers"), res => {
        var list = res || [];
        _this.adviserList = list;
        _this.marketList = list;
      });
    }
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
